// extracted by mini-css-extract-plugin
export default {"routeName":"TramAutoCompleteResult_routeName__ujIr0"};